import { Box, IconButton, Tooltip } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { PerUnitProduct } from '@vy/services';
import { type FixedProduct, type UsageProduct } from '@vy/types';
import { isNotNullOrUndefined, isNullOrUndefined } from '@vy/utils';
import { FC, useState } from 'react';
import { VyTableCell } from '../../../../components/new-design/table/vy-table/VyTableCell';
import type { OnEditAnrokHandler } from './anrok-cell-types';

type AnrokCellProps = {
  product?: FixedProduct | PerUnitProduct | UsageProduct;
  productName?: string;
  value?: string;
  isInherited?: boolean;
  catalogAnrokId?: string;
  overrideAnrokId?: string;
  onEditAnrok?: OnEditAnrokHandler;
  disableEdit?: boolean;
};

export const AnrokCell: FC<AnrokCellProps> = ({
  value,
  product,
  productName,
  isInherited = false,
  catalogAnrokId,
  overrideAnrokId,
  onEditAnrok,
  disableEdit = false,
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const canEdit = isNotNullOrUndefined(onEditAnrok) && !disableEdit;

  const cellContent = (
    <VyTableCell
      value={value}
      containerClassName={isInherited ? 'opacity-60' : undefined}
    />
  );

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        width: '100%',
        height: '100%',
      }}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isInherited ? (
        <Tooltip title="Inherited from catalog" placement="top">
          <span>{cellContent}</span>
        </Tooltip>
      ) : (
        cellContent
      )}
      {canEdit && (
        <IconButton
          size="small"
          data-vy="contract-page-anrok-edit-button"
          sx={{
            opacity: isHovering ? 1 : 0,
            transition: 'opacity 0.2s',
            padding: '4px',
          }}
          onClick={(event) => {
            event.stopPropagation();

            if (isNullOrUndefined(product) || isNullOrUndefined(productName)) {
              return;
            }

            onEditAnrok?.(product, productName, { catalogAnrokId, overrideAnrokId });
          }}
        >
          <VyIcon icon="Pen" transform="scale(0.8)" />
        </IconButton>
      )}
    </Box>
  );
};
